module.exports = __webpack_public_path__ + "static/tania-avatar-98e2c1a8c2893157248f6b5ee16d10d4.jpg";